HTML = {};

IDENTITY = function (x) { return x; };
SLICE = Array.prototype.slice;
